import {AxiosResponse} from "axios";
import {Response} from "./dto/Response"
import apiMultipart from "../config/api-multipart";
import Bowser from "bowser";
import ipApiJson from "../config/ip-api-json";

export class ApplicationAPI {

    baseUrl = "/application"

    async getApplicationTheme(verificationId: string) {
        const browserInfo = Bowser.parse(window.navigator.userAgent)
        const ipAddress = await ipApiJson.get("https://api.ipify.org/?format=json")
        const config = {
            headers: {
                'Browser-name': browserInfo.browser.name,
                'Browser-version': browserInfo.browser.version,
                'OS': browserInfo.os.name,
                ipAddress: ipAddress.data.ip
            }
        }
        const response: AxiosResponse<Response<string>> = await apiMultipart.get(`${this.baseUrl}/theme/${verificationId}`, config);
        if (response.status === 200) {
            return response.data.data
        }
        throw new Error(response.statusText)
    }


}